var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloMutation',{attrs:{"mutation":function (gql) { return _vm.createChapterConnectorQuery; },"variables":{
    fromChapterId: _vm.chapter.id,
  },"update":_vm.updateCache},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var mutate = ref.mutate;
  var loading = ref.loading;
return [_c('v-btn',{staticClass:"mt-6 rounded-xl",attrs:{"color":"primaryAction","small":"","disabled":loading,"loading":loading},on:{"click":function($event){return mutate()}}},[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v(_vm._s(_vm.$t("storyHub.chapterList.addNewChapterConnection")))],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }